"use strict";const r=require("./index18.js"),t=require("./index252.js");var n=r._export,o=t.objectToArray.entries;n({target:"Object",stat:!0},{entries:function(e){return o(e)}});
